var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/Consultation/Consultation.jinja"] = require( "front/components/Consultation/Consultation.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexHero/IndexHero.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexHero/IndexHero.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/Consultation/Consultation.jinja", false, "assets/app/front/components/IndexHero/IndexHero.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "Consultation")) {
var t_7 = t_4.Consultation;
} else {
cb(new Error("cannot import 'Consultation'")); return;
}
context.setVariable("Consultation", t_7);
output += "\n\n<div class=\"IndexHero\">\n    <div class=\"IndexHero-content\">\n        <div class=\"IndexHero-title\">Агентство недвижимости в&nbsp;Москве</div>\n        <div class=\"IndexHero-contentBlock\">\n            <div class=\"IndexHero-text\">\n                Снимаем с вас все трудности. Помогаем&nbsp;продать, купить, сдать, арендовать, приватизировать, получить&nbsp;ипотеку.\n                Организуем все&nbsp;этапы:&nbsp;от поиска покупателей и&nbsp;объектов до регистрации перехода&nbsp;права собственности\n                в государственных органах.\n            </div>\n            ";
if(!(lineno = 13, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")]))) {
output += "\n                <div class=\"IndexHero-consultation\">";
output += runtime.suppressValue((lineno = 14, colno = 67, runtime.callWrap(t_7, "Consultation", context, [runtime.makeKeywordArgs({"mods": ["relative","isVisible"]})])), env.opts.autoescape);
output += "</div>\n            ";
;
}
output += "\n        </div>\n    </div>\n    <div class=\"IndexHero-city\">\n        <div class=\"IndexHero-cityObject IndexHero-cityObject--1\">\n            ";
output += runtime.suppressValue((lineno = 20, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["object_1",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "</div>\n        <div class=\"IndexHero-cityObject IndexHero-cityObject--2\">\n            ";
output += runtime.suppressValue((lineno = 22, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["object_2",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
output += "</div>\n        <div class=\"IndexHero-cityObject IndexHero-cityObject--3\">\n            ";
output += runtime.suppressValue((lineno = 24, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["object_3",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
output += "</div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexHero/IndexHero.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexHero/IndexHero.jinja
// module id = 29
// module chunks = 0